var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _rect, _rect2, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _rect3, _rect4, _rect5, _rect6, _rect7, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _rect8, _rect9, _rect10, _rect11, _rect12, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _rect13, _rect14, _rect15, _rect16, _rect17, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _rect18, _rect19, _rect20, _circle, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _rect21, _rect22, _rect23, _rect24, _rect25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 323,
    viewBox: "0 0 481 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1785 178.698C35.1785 178.698 40.265 177.257 43.8041 180.558C43.8041 180.558 41.7316 182.622 36.5382 180.711L35.1785 178.698Z",
    fill: "#F2463A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6184 178.678C34.6184 178.678 31.7916 183.145 33.9379 187.477C33.9379 187.477 36.5072 186.084 36.1557 180.557L34.6184 178.678Z",
    fill: "#F2463A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8637 172.34C30.8637 172.34 32.4873 168.296 41.4028 172.643C41.4028 172.643 40.5971 175.327 36.912 175.552C33.227 175.776 32.0628 174.229 30.8637 172.34Z",
    fill: "#F2463A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2941 172.13C30.2941 172.13 25.9387 172.138 26.6733 182.032C26.6733 182.032 29.4667 182.279 31.0361 178.939C32.6055 175.599 31.6082 173.943 30.2941 172.13Z",
    fill: "#F2463A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8707 164.569C26.8707 164.569 28.5028 157.583 37.8337 161.321C37.8337 161.321 36.5521 167.707 28.0364 166.746L26.8707 164.569Z",
    fill: "#F2463A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0027 154.867C23.0027 154.867 26.7992 147.548 35.5921 152.899C35.5921 152.899 33.4995 159.587 23.9743 157.202L23.0027 154.867Z",
    fill: "#F2463A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9182 145.445C20.9182 145.445 25.5109 138.603 34.2529 143.886C34.2529 143.886 29.8466 149.934 21.104 147.034L20.9182 145.445Z",
    fill: "#F2463A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0019 136.287C19.0019 136.287 23.6339 129.158 32.0238 134.411C32.0238 134.411 26.6153 140.86 19.1842 137.806L19.0019 136.287Z",
    fill: "#F2463A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.527 128.033C18.527 128.033 23.2132 119.006 31.0597 123.846C31.0597 123.846 25.8241 131.742 18.7134 129.634L18.527 128.033Z",
    fill: "#F2463A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7127 118.249C18.7127 118.249 23.7513 109.258 31.4719 114.793C31.4719 114.793 25.2033 122.829 18.8893 119.773L18.7127 118.249Z",
    fill: "#F2463A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7136 109.434C19.7136 109.434 25.9112 100.807 32.4771 103.191C32.4771 103.191 26.0314 112.329 19.6345 111.553L19.7136 109.434Z",
    fill: "#F2463A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2446 101.003C21.2446 101.003 28.3478 90.5069 33.4873 93.1279C33.4873 93.1279 28.3035 101.229 20.8618 102.87L21.2446 101.003Z",
    fill: "#F2463A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7266 91.1461C23.7266 91.1461 30.0014 82.5154 35.4802 83.8301C35.4802 83.8301 30.2777 92.6335 23.0508 93.6933L23.7266 91.1461Z",
    fill: "#F2463A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9616 81.9374C25.9616 81.9374 33.0327 73.5464 36.6432 74.4547C36.6432 74.4547 31.8763 83.4147 25.8083 83.6386L25.9616 81.9374Z",
    fill: "#F2463A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1649 73.4135C28.1649 73.4135 33.9692 63.6829 37.7737 63.9517C37.7737 63.9517 34.5614 72.383 28.2749 74.3113L28.1649 73.4135Z",
    fill: "#F2463A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3212 62.0219C30.3212 62.0219 35.5683 54.4761 38.8423 54.1116C38.8423 54.1116 35.1635 63.802 30.3382 64.2792L30.3212 62.0219Z",
    fill: "#F2463A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5148 54.4633L35.6828 39.5431C35.6828 39.5431 37.5081 52.3772 31.0795 57.1887L31.5148 54.4633Z",
    fill: "#F2463A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0477 38.4875C32.0477 38.4875 31.6188 26.4932 30.885 25.5966C30.885 25.5966 36.2179 34.9884 32.6234 43.7417L32.0477 38.4875Z",
    fill: "#F2463A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.627 164.439C26.627 164.439 20.1294 161.392 17.2861 171.035C17.2861 171.035 23.0953 173.979 27.6126 166.695L26.627 164.439Z",
    fill: "#F2463A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7651 154.51C22.7651 154.51 14.9151 151.994 12.4404 161.999C12.4404 161.999 18.6395 165.257 23.7073 156.852L22.7651 154.51Z",
    fill: "#F2463A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6402 146.059C20.6402 146.059 14.5924 140.464 7.30552 147.618C7.30552 147.618 12.9904 152.488 20.826 147.648L20.6402 146.059Z",
    fill: "#F2463A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8263 136.338C18.8263 136.338 12.6761 130.475 5.72852 137.522C5.72852 137.522 12.4783 142.536 19.0026 137.856L18.8263 136.338Z",
    fill: "#F2463A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5553 128.246C18.5553 128.246 13.6737 119.325 5.92873 124.315C5.92873 124.315 11.3364 132.098 18.4024 129.834L18.5553 128.246Z",
    fill: "#F2463A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1835 118.148C19.1835 118.148 14.3114 109.06 6.4857 114.458C6.4857 114.458 12.6119 122.592 18.9793 119.662L19.1835 118.148Z",
    fill: "#F2463A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5196 109.388C20.5196 109.388 17.8053 99.1178 10.8047 98.9898C10.8047 98.9898 13.5591 109.829 19.8161 111.378L20.5196 109.388Z",
    fill: "#F2463A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4226 101C21.4226 101 19.3697 88.4923 13.605 88.7189C13.605 88.7189 14.9215 98.2447 20.9859 102.858L21.4226 101Z",
    fill: "#F2463A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2814 90.7146C24.2814 90.7146 21.3478 80.455 15.7537 79.8115C15.7537 79.8115 17.6136 89.8689 24.0433 93.3411L24.2814 90.7146Z",
    fill: "#F2463A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5968 81.9356C26.5968 81.9356 25.266 71.0438 21.7474 69.8338C21.7474 69.8338 20.8346 79.9397 25.7981 83.443L26.5968 81.9356Z",
    fill: "#F2463A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4068 73.2589C28.4068 73.2589 26.6225 62.0925 22.9925 60.9118C22.9925 60.9118 22.846 69.9337 27.977 74.0587L28.4068 73.2589Z",
    fill: "#F2463A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9155 62.8543C30.9155 62.8543 29.8271 53.7332 27.1143 51.8771C27.1143 51.8771 25.8423 62.1671 29.8437 64.8447L30.9155 62.8543Z",
    fill: "#F2463A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1735 54.0466L26.9985 39.1303C26.9985 39.1303 25.1988 51.9601 31.6058 56.7705L31.1735 54.0466Z",
    fill: "#F2463A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8686 38.8868C29.8686 38.8868 22.5225 29.3988 22.5184 28.2402C22.5184 28.2402 24.4232 38.842 32.7737 43.3004L29.8686 38.8868Z",
    fill: "#F2463A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2081 35.7918C30.2081 35.7918 22.7058 21.9617 19.9708 21.0932C19.9708 21.0932 28.7542 24.3356 30.6718 35.3171L30.2081 35.7918Z",
    fill: "#F2463A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3189 64.3633L29.9111 64.2884C32.9351 47.7492 32.9621 37.3961 29.9872 35.1668L30.2378 34.8275C33.3926 37.2084 33.4178 47.4162 30.3189 64.3633Z",
    fill: "#444053"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2115 103.328L20.6105 103.192C20.9566 101.665 21.3431 100.113 21.7604 98.5827C25.3768 85.2408 28.3409 72.882 30.0658 63.4549L30.5493 63.1397C28.8191 72.579 25.9844 85.3889 22.3626 98.743C21.9453 100.273 21.5582 101.814 21.2115 103.328Z",
    fill: "#444053"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8702 189.795C43.7831 189.716 34.7988 181.706 27.4776 167.094C23.187 158.542 20.2786 149.364 18.8606 139.902C17.0852 128.075 18.0289 114.521 20.8886 101.977L21.4181 102.468C15.0009 130.621 21.5242 153.342 28.2065 166.696C35.4626 181.192 44.3334 189.071 44.4217 189.173L43.8702 189.795Z",
    fill: "#444053"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M436.726 159.617C436.726 159.617 430.729 141.548 420.725 140.825C420.725 140.825 424.809 158.606 436.528 164.309L436.726 159.617Z",
    fill: "#F2463A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M437.944 142.765C437.944 142.765 430.461 124.677 423.862 124.267C423.862 124.267 427.114 142.08 437.303 145.734L437.944 142.765Z",
    fill: "#F2463A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M436.023 158.587C436.023 158.587 446.558 142.726 456.415 144.665C456.415 144.665 447.813 160.744 435.005 163.176L436.023 158.587Z",
    fill: "#F2463A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M436.83 142.406C436.83 142.406 444.99 124.613 451.621 124.484C451.621 124.484 447.704 142.156 437.38 145.427L436.83 142.406Z",
    fill: "#F2463A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M369.924 302.254C369.924 302.254 362.058 297.063 354.262 300.756C354.262 300.756 356.662 305.377 366.532 304.936L369.924 302.254Z",
    fill: "#F2463A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M370.872 302.529C370.872 302.529 373.265 311.644 367.262 317.846C367.262 317.846 363.652 314.089 367.262 304.885L370.872 302.529Z",
    fill: "#F2463A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M380.696 293.78C380.696 293.78 380.12 286.028 362.615 288.595C362.615 288.595 362.532 293.6 368.676 295.969C374.821 298.337 377.637 296.34 380.696 293.78Z",
    fill: "#F2463A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M381.753 293.728C381.753 293.728 389.152 296.103 382.553 312.52C382.553 312.52 377.669 311.432 376.792 304.897C375.916 298.362 378.553 296.09 381.753 293.728Z",
    fill: "#F2463A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M391.686 282.732C391.686 282.732 392.684 269.969 374.801 271.281C374.801 271.281 373.521 282.802 388.53 285.798L391.686 282.732Z",
    fill: "#F2463A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M403.514 268.331C403.514 268.331 401.063 253.872 383.18 258.18C383.18 258.18 383.116 270.68 400.596 271.774L403.514 268.331Z",
    fill: "#F2463A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M412.143 253.443C412.143 253.443 408.04 239.362 390.323 243.574C390.323 243.574 394.541 256.24 410.971 256.042L412.143 253.443Z",
    fill: "#F2463A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M420.355 238.901C420.355 238.901 416.335 224.289 399.233 228.66C399.233 228.66 404.936 242.543 419.222 241.372L420.355 238.901Z",
    fill: "#F2463A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M425.642 225.089C425.642 225.089 422.557 207.218 406.606 211.174C406.606 211.174 411.24 227.431 424.47 227.694L425.642 225.089Z",
    fill: "#F2463A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M430.603 208.402C430.603 208.402 426.897 190.385 410.761 195.601C410.761 195.601 417.091 212.627 429.463 210.867L430.603 208.402Z",
    fill: "#F2463A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M433.674 192.868C433.674 192.868 427.792 174.857 415.317 175.343C415.317 175.343 421.327 194.372 432.598 196.465L433.674 192.868Z",
    fill: "#F2463A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M435.62 177.718C435.62 177.718 429.219 156.033 419.068 157.703C419.068 157.703 423.497 174.281 435.261 181.097L435.62 177.718Z",
    fill: "#F2463A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M438.775 127.07C438.775 127.07 434.173 107.427 427.555 105.795C427.555 105.795 428.464 121.867 438.11 128.542L438.775 127.07Z",
    fill: "#F2463A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M441.279 106.531C441.279 106.531 436.446 90.8751 431.089 88.4877C431.089 88.4877 432.145 106.947 440.05 110.365L441.279 106.531Z",
    fill: "#F2463A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M443.333 93.0448L444.306 65.4328C444.306 65.4328 434.308 86.273 442.597 97.9157L443.333 93.0448Z",
    fill: "#F2463A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M451.064 65.6057C451.064 65.6057 458.278 45.4439 460.025 44.3174C460.025 44.3174 445.886 57.4002 447.262 74.2273L451.064 65.6057Z",
    fill: "#F2463A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M392.173 282.649C392.173 282.649 404.859 280.985 404.481 298.919C404.481 298.919 393.018 300.782 389.273 285.958L392.173 282.649Z",
    fill: "#F2463A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M404.11 267.844C404.11 267.844 418.767 267.8 417.551 286.15C417.551 286.15 405.249 288.345 401.191 271.314L404.11 267.844Z",
    fill: "#F2463A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M412.29 254.627C412.29 254.627 425.597 248.387 434.11 264.497C434.11 264.497 421.82 269.694 411.112 257.232L412.29 254.627Z",
    fill: "#F2463A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M420.649 239.036C420.649 239.036 434.276 232.398 442.276 248.131C442.276 248.131 428.08 253.021 419.522 241.525L420.649 239.036Z",
    fill: "#F2463A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M425.469 225.479C425.469 225.479 438.584 212.947 449.049 225.62C449.049 225.62 435.652 235.931 424.867 228.27L425.469 225.479Z",
    fill: "#F2463A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M429.859 207.973C429.859 207.973 443.051 195.172 453.432 208.562C453.432 208.562 438.621 219.078 429.385 210.662L429.859 207.973Z",
    fill: "#F2463A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M432.317 192.356C432.317 192.356 442.481 176.355 454.451 179.933C454.451 179.933 443.902 196.875 432.433 196.12L432.317 192.356Z",
    fill: "#F2463A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M435.319 177.616C435.319 177.616 445.56 157.46 455.25 160.974C455.25 160.974 447.864 176.464 435.057 181.014L435.319 177.616Z",
    fill: "#F2463A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M438.449 126.686C438.449 126.686 447.518 108.656 454.329 108.624C454.329 108.624 449.688 124.037 438.75 128.267L438.449 126.686Z",
    fill: "#F2463A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M439.812 107.638C439.812 107.638 446.597 92.7248 452.21 91.0351C452.21 91.0351 448.818 109.213 440.555 111.594L439.812 107.638Z",
    fill: "#F2463A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M444.139 92.552L459.302 69.4524C459.302 69.4524 455.417 92.2384 441.925 96.9748L444.139 92.552Z",
    fill: "#F2463A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M454.546 67.4621C454.546 67.4621 472.167 55.301 472.807 53.3296C472.807 53.3296 463.846 70.3679 447.205 73.3762L454.546 67.4621Z",
    fill: "#F2463A"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M455.603 61.9895C455.603 61.9895 475.841 42.5446 481 42.5638C481 42.5638 464.314 43.3254 455.116 60.959L455.603 61.9895Z",
    fill: "#F2463A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M439.998 110.525L440.74 110.621C444.542 80.8581 450.085 63.2565 456.345 61.0996L456.101 60.3955C449.47 62.6997 443.902 80.0388 439.998 110.525Z",
    fill: "#444053"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M434.417 181.68L435.531 181.776C435.768 178.998 435.947 176.156 436.068 173.321C437.131 148.691 438.776 126.072 440.939 109.117L440.299 108.317C438.129 125.304 436.024 148.608 434.961 173.276C434.833 176.092 434.654 178.921 434.417 181.68Z",
    fill: "#444053"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M349.148 316.418C349.34 316.335 368.945 307.579 389.292 286.694C401.214 274.466 411.12 260.424 418.639 245.09C428.048 225.933 433.783 202.392 435.703 179.523L434.544 180.067C430.224 231.4 406.856 266.475 388.275 285.58C368.126 306.273 348.738 314.94 348.546 315.023L349.148 316.418Z",
    fill: "#444053"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.835,
    y: 195.216,
    width: 348.847,
    height: 82.2753,
    fill: "#F2463A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 303.499,
    y: 201.981,
    width: 66.1859,
    height: 68.7456,
    fill: "#E9E9E9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 207.649H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 211.122H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 214.596H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 218.07H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 221.544H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 225.018H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 228.492H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 231.966H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 235.439H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 238.913H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 242.387H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 245.861H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 249.335H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 252.809H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 256.283H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 259.756H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 263.23H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 270.178H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 266.704H369.682",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M303.497 204.175H369.683",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 295.27,
    y: 195.216,
    width: 82.4581,
    height: 6.76486,
    fill: "#D23B30"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 295.27,
    y: 270.726,
    width: 82.4581,
    height: 6.76486,
    fill: "#D23B30"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 295.27,
    y: 195.216,
    width: 8.22753,
    height: 82.2753,
    fill: "#D23B30"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4619,
    y: 150.056,
    width: 348.847,
    height: 45.16,
    fill: "#3D4273"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 318.123,
    y: 153.769,
    width: 66.1859,
    height: 37.7337,
    fill: "#E9E9E9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 156.88H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 158.787H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 160.694H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 162.6H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 164.507H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 166.414H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 168.321H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 170.227H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 172.134H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 174.041H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 175.948H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 177.854H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 179.761H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 181.668H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 183.575H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 185.481H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 187.388H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 191.202H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 189.295H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 154.973H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 309.896,
    y: 150.056,
    width: 82.4581,
    height: 3.71316,
    fill: "#1F244D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 309.896,
    y: 191.503,
    width: 82.4581,
    height: 3.71316,
    fill: "#1F244D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 309.896,
    y: 150.056,
    width: 8.22753,
    height: 45.16,
    fill: "#1F244D"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4619,
    y: 150.056,
    width: 348.847,
    height: 45.16,
    fill: "#4B518C"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 318.123,
    y: 153.769,
    width: 66.1859,
    height: 37.7337,
    fill: "#E9E9E9"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 156.88H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 158.787H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 160.694H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 162.6H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 164.507H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 166.414H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 168.321H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 170.227H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 172.134H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 174.041H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 175.948H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 177.854H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 179.761H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 181.668H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 183.575H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 185.481H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 187.388H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 191.202H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 189.295H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M318.123 154.973H384.309",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 313.003,
    y: 150.056,
    width: 79.35,
    height: 3.65668,
    fill: "#3D4273"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 313.003,
    y: 191.559,
    width: 79.35,
    height: 3.65668,
    fill: "#3D4273"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 313.003,
    y: 150.056,
    width: 5.11935,
    height: 45.16,
    fill: "#3D4273"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8794,
    y: 277.491,
    width: 348.847,
    height: 45.16,
    fill: "#32386B"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 311.542,
    y: 281.204,
    width: 66.1859,
    height: 37.7337,
    fill: "#E9E9E9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 284.315H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 286.222H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 288.129H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 290.036H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 291.942H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 293.849H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 295.756H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 297.663H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 299.569H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 301.476H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 303.383H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 305.29H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 307.196H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 309.103H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 311.01H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 312.917H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 314.823H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 318.637H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 316.73H377.727",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M311.542 282.409H377.728",
    stroke: "#D2D2D2",
    strokeWidth: 3
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 306.422,
    y: 277.491,
    width: 79.35,
    height: 3.65668,
    fill: "#1F244D"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 306.422,
    y: 318.994,
    width: 79.35,
    height: 3.65668,
    fill: "#1F244D"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 306.422,
    y: 277.491,
    width: 5.11935,
    height: 45.16,
    fill: "#1F244D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9465,
    cy: 234.25,
    r: 29.7649,
    fill: "#F56F65"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.768 96.79L152.857 76.2666C147.742 72.9807 141.711 67.1866 138.654 63.9007C138.021 62.8791 137.457 61.0646 141.033 62.6046C144.608 64.1446 150.395 68.1243 151.294 67.1789C152.194 66.2336 150.425 64.1294 151.973 63.0316C152.989 62.2793 155.34 65.8931 159.025 73.8727L176.789 88.4648L168.768 96.79Z",
    fill: "#A6A6A6"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.135 28.3655C243.284 24.6679 245.419 20.1394 245.06 15.0619C244.039 0.43168 223.668 3.62608 219.711 11.0365C215.754 18.4469 216.219 37.1482 221.335 38.4824C223.378 39.0084 227.731 37.72 232.153 35.0517L229.378 54.706H245.785L240.135 28.3655Z",
    fill: "#A6A6A6"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.393 31.6593C243.46 22.5106 249.322 16.2515 248.43 12.1574C248.234 10.928 247.673 9.78576 246.821 8.87799C245.969 7.97022 244.865 7.33862 243.65 7.06469C242.313 1.65175 237.993 -0.650664 230.69 0.157466C219.749 1.36966 213.078 5.91349 215.96 15.9084C218.613 15.9084 221.808 14.9554 226.23 16.5945C227.64 17.113 228.639 18.7292 229.279 21.4433H231.277C233.213 18.226 235.127 17.0443 237.017 17.8982C238.908 18.7521 239.335 20.8232 238.298 24.1117L239.282 31.6593H241.393Z",
    fill: "#191847"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.24 221.509C147.719 205.046 156.84 192.848 161.602 184.914C169.752 171.313 176.423 159.206 178.535 154.586C183.551 143.555 166.969 138.393 163.218 143.539C157.536 151.321 145.406 175.816 126.83 217.026L134.24 221.509Z",
    fill: "#A6A6A6"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.861 216.721L186.943 153.58C192.28 142.068 166.397 134.521 162.456 139.857C153.505 152.017 132.227 199.994 129.559 203.623L161.861 216.721Z",
    fill: "#8991DC"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.669 204.058C223.782 196.93 206.011 172.953 196.328 163.026C193.546 160.183 190.832 157.446 188.262 154.892C180.639 147.314 165.437 160.053 173.053 166.96C192.021 184.152 219.703 207.367 222.013 209.433C225.253 212.33 231.741 208.541 228.669 204.058Z",
    fill: "#A6A6A6"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.526 200.841C228.797 201.786 229.907 202.932 230.811 204.233C231.666 205.834 232.39 207.502 232.977 209.219L199.569 228.53C197.027 226.162 196.634 224.322 198.387 223.011C200.141 221.699 201.574 220.597 202.687 219.702L214.214 203.822C214.322 203.675 214.484 203.577 214.663 203.549C214.843 203.52 215.027 203.563 215.175 203.669L217.569 205.514C219.275 205.452 220.95 205.034 222.486 204.287C223.705 203.448 224.743 202.372 225.536 201.123C225.639 200.976 225.77 200.851 225.922 200.755C226.074 200.658 226.243 200.593 226.421 200.563C226.598 200.532 226.779 200.537 226.954 200.577C227.129 200.617 227.295 200.691 227.442 200.795L227.526 200.841Z",
    fill: "#E9E9E9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.034 219.046C140.663 220.499 141.052 222.044 141.186 223.621C141.123 225.431 140.916 227.233 140.568 229.011H101.984C100.967 225.702 101.546 223.923 103.722 223.674C105.897 223.425 107.691 223.186 109.104 222.957L127.02 214.968C127.186 214.893 127.375 214.887 127.545 214.951C127.715 215.016 127.853 215.145 127.928 215.311L129.079 218.101C130.588 218.901 132.247 219.378 133.95 219.504C135.422 219.378 136.853 218.958 138.159 218.269C138.49 218.119 138.866 218.106 139.206 218.233C139.546 218.36 139.822 218.617 139.973 218.947C139.973 218.947 140.027 219.016 140.034 219.046Z",
    fill: "#E9E9E9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.97 156.729C216.808 153.334 230.785 151.013 237.901 149.768C258.081 146.208 263.967 135.344 260.49 111.649H223.301C218.376 113.067 197.812 121.855 161.609 138.012C155.098 141.252 156.31 150.782 157.5 153.923C157.545 154.05 168.526 172.868 190.442 210.378L220.862 190.998L195.947 159.016C195.253 157.689 195.276 156.927 195.97 156.729Z",
    fill: "#ABB2FF"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.801 92.8777L268.628 94.6769C280.867 121.864 287.438 136.278 288.343 137.92C290.394 141.617 287.802 147.953 286.773 151.315C291.652 152.839 290.219 145.216 296.386 147.205C302.02 149.027 306.625 153.022 312.32 148.463C313.014 147.899 313.631 146.039 311.459 144.918C306.046 142.105 298.109 136.997 296.897 135.144C295.235 132.644 290.536 118.555 282.801 92.8777Z",
    fill: "#A6A6A6"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.422 43.2706L230.506 42.2566C217.256 53.6924 214.961 77.9363 198.112 88.0913C189.352 93.367 174.051 80.6656 161.807 74.7953L156.227 84.0049C158.621 97.6669 204.257 118.953 212.834 110.437C230.14 93.2755 237.047 64.3429 236.422 43.2706Z",
    fill: "#D23B30"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.192 117.596H209.885C207.498 117.596 207.948 114.142 208.291 112.396C212.278 92.2995 227.846 70.6325 227.846 42.0201L242.934 39.6567C255.414 59.7304 259.729 84.4393 262.192 117.596Z",
    fill: "#D2D2D2"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.772 59.3872C262.893 59.0431 263.932 58.4751 264.827 57.7177C265.722 56.9603 266.455 56.0291 266.979 54.9806C272.491 45.0239 270.502 39.5499 264.608 37.7507C258.715 35.9515 253.462 39.6567 244.07 39.6567C243.6 39.6525 243.131 39.6857 242.667 39.7558L237.94 40.0226C224.395 85.9488 220.659 116.592 226.733 131.951L270.029 123.001C272.469 128.688 286.374 133.617 288.615 137.497L299.975 135.149C301.027 101.009 279.063 83.1966 261.772 59.3872Z",
    fill: "#F2463A"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 236.034,
    y: 195.257,
    width: 38.099,
    height: 82.151,
    fill: "#F56F65"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 61.9102,
    y: 150.015,
    width: 11.9059,
    height: 45.2426,
    fill: "#3D4273"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 80.6621,
    y: 150.015,
    width: 11.9059,
    height: 45.2426,
    fill: "#3D4273"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 272.943,
    y: 150.015,
    width: 25.3001,
    height: 45.2426,
    fill: "#3D4273"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 64.8867,
    y: 286.338,
    width: 128.882,
    height: 22.9189,
    fill: "#4B518C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.2d3f74679313a2a709ffa33984af3431.svg";
export { ForwardRef as ReactComponent };